module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("2.")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle1"
  }, [_vm._v("A POT OF TEA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mr. and Mrs. Beresford took possession of the offices of the International Detective Agency a few days later. They were on the second floor of a somewhat dilapidated building in Bloomsbury. In the small outer office, Albert relinquished the role of a Long Island butler, and took up that of office boy, a part which he played to perfection. A paper bag of sweets, inky hands, and a tousled head was his conception of the character.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the outer office, two doors led into inner offices. On one door was painted the legend “Clerks.” On the other “Private.” Behind the latter was a small comfortable room furnished with an immense business like desk, a lot of artistically labeled files, all empty, and some solid leather—seated chairs. Behind the desk sat the pseudo Mr. Blunt trying to look as though he had run a detective agency all his life. A telephone, of course, stood at his elbow. Tuppence and he had rehearsed several good telephone effects, and Albert also had his instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the adjoining room was Tuppence, a typewriter, the necessary tables and chairs of an inferior type to those in the room of the great Chief, and a gas ring for making tea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nothing was wanting, in fact, save clients.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence, in the first ecstasies of initiation, had a few bright hopes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It will be too marvelous,” she declared. “We will hunt down murderers, and discover the missing family jewels, and find people who’ve disappeared and detect embezzlers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this point Tommy felt it his duty to strike a more discouraging note. “Calm yourself, Tuppence, and try and forget the cheap fiction you are in the habit of reading. Our clientele, if we have any clientele at all—will consist solely of husbands who want their wives shadowed, and wives who "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("want their husbands shadowed. Evidence for divorce is the sole prop of private inquiry agents.”")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ugh!” said Tuppence wrinkling a fastidious nose. “We shan’t touch divorce cases. We must raise the tone of our new profession.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ye—es,” said Tommy doubtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And now a week after installation they compare notes rather ruefully. “Three idiotic women whose husbands go away for weekends,” sighed Tommy. “Anyone come whilst I was out at lunch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A fat old man with a flighty wife,” sighed Tuppence sadly. “I’ve read in the papers for years that the divorce evil was growing, but somehow I never seemed to realize it until this last week. I’m sick and tired of saying ‘We don’t undertake divorce cases.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ve put it in the advertisements now,” Tommy reminded her. “So it won’t be so bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure we advertise in the most tempting way too,” said Tuppence, in a melancholy voice. “All the same, I’m not going to be beaten. If necessary, I shall commit a crime myself, and you will detect it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what good would that do? Think of my feelings when I bid you a tender farewell at Bow Street—or is it Vine Street?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are thinking of your bachelor days,” said Tuppence pointedly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Old Bailey, that is what I mean,” said Tommy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” said Tuppence, “something has got to be done about it. Here we are bursting with talent and no chance of exercising it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I always like your cheery optimism, Tuppence. You seem to have no doubt whatever that you have talent to exercise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” said Tuppence opening her eyes very wide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And yet you have no expert knowledge whatever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I have read every detective novel that has been published in the last ten years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So have I,” said Tommy, “but I have a sort of feeling that that wouldn’t really help us much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You always were a pessimist, Tommy. Belief in oneself—that is the great thing.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“Well, you have got it all right,” said her husband.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course it is all right in detective stories,” said Tuppence thoughtfully, “because one works backwards. I mean if one knows the solution one can arrange the clues. I wonder now—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She paused, wrinkling her brows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes?” said Tommy, inquiringly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have got a sort of an idea,” said Tuppence. “It hasn’t quite come yet but it’s coming.” She rose resolutely. “I think I shall go and buy that hat I told you about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh God!” said Tommy. “Another hat!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a very nice one,” said Tuppence with dignity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She went out with a resolute look on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once or twice in the following days Tommy inquired curiously about the idea. Tuppence merely shook her head and told him to give her time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then, one glorious morning, the first client arrived, and all else was forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a knock on the outer door of the office Albert, who had just placed an acid drop between his lips, roared out an indistinct ‘come in.’ He then swallowed the acid drop whole in his surprise and delight. For this looked like the Real Thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A tall young man, exquisitely and beautifully dressed, stood hesitating in the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A toff, if ever there was one,” said Albert to himself. His judgment in such matters was good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man was about twenty—four years of age, had beautifully slicked—back hair, a tendency to pink rims round the eyes, and practically no chin to speak of.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an ecstasy, Albert pressed a button under his desk, and almost immediately a perfect fusilade of typing broke out from the direction of “Clerks.” Tuppence had rushed to the post of duty. The effect of this hum of industry was to overawe the young man still further.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I say,” he remarked. “Is this the whatnot—detective agency—Blunt’s Brilliant Detectives? All that sort of stuff, you know? Eh?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“Did you want, sir, to speak to Mr. Blunt himself?” inquired Albert, with an air of doubt as to whether such a thing could be managed.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well—yes, laddie, that was the jolly old idea. Can it be done?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You haven’t an appointment, I suppose?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The visitor became more and more apologetic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Afraid I haven’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s always wise, sir, to ring up on the phone first. Mr. Blunt is so terribly busy. He’s engaged on the telephone at the moment. Called into consultation by Scotland Yard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man seemed suitably impressed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Albert lowered his voice, and imported information in a friendly fashion. “Important theft of documents from a Government Office. They want Mr. Blunt to take up the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! really. I say. He must be no end of a fellow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Boss, sir,” said Albert, “is It.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man sat down on a hard chair, completely unconscious of the fact that he was being subjected to keen scrutiny by two pairs of eyes looking through cunningly contrived peep holes—those of Tuppence, in the intervals of frenzied typing, and those of Tommy awaiting the suitable moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Presently a bell rang with violence on Albert’s desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Boss is free now. I will find out whether he can see you,” said Albert, and disappeared through the door marked “Private.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He reappeared immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you come this way, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The visitor was ushered into the private office, and a pleasant faced young man with red hair and an air of brisk capability rose to greet him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sit down. You wished to consult me? I am Mr. Blunt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! Really. I say, you’re awfully young, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The day of the Old Men is over,” said Tommy waving his hand. “Who caused the War? The Old Men. Who is responsible for the present state of unemployment? The Old Men. Who is responsible for every single rotten thing that has happened? Again I say, the Old Men!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“I expect you are right,” said the client. “I know a fellow who is a poet—at least he says he is a poet—and he always talks like that.”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me tell you this, sir, not a person on my highly trained staff is a day over twenty—five. That is the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since the highly trained staff consisted of Tuppence and Albert, the statement was truth itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And now—the facts,” said Mr. Blunt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want you to find someone that’s missing,” blurted out the young man. “Quite so. Will you give me the details?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you see, it’s rather difficult. I mean, it’s a frightfully delicate business and all that. She might be frightfully waxy about it. I mean—well, it’s so dashed difficult to explain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked helplessly at Tommy. Tommy felt annoyed. He had been on the point of going out to lunch, but he foresaw that getting the facts out of this client would be a long and tedious business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did she disappear of her own free will, or do you suspect abduction?” he demanded crisply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” said the young man. “I don’t know anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy reached for a pad and pencil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“First of all,” he said, “will you give me your name? My office boy is trained never to ask names. In that way consultations can remain completely confidential.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! rather,” said the young man. “Jolly good idea. My name—er—my name’s Smith.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! no,” said Tommy. “The real one, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His visitor looked at him in awe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Er—St. Vincent,” he said. “Lawrence St. Vincent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a curious thing,” said Tommy, “how very few people there are whose real name is Smith. Personally, I don’t know anyone called Smith. But nine men out of ten who wish to conceal their real name give that of Smith. I am writing a monograph upon the subject.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("At that moment a buzzer purred discreetly on his desk. That meant that Tuppence was requesting to take hold. Tommy, who wanted his lunch, and ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("who felt profoundly unsympathetic towards Mr. St. Vincent, was only too pleased to relinquish the helm.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me,” he said, and picked up the telephone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Across his face there shot rapid changes—surprise, consternation, slight elation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t say so,” he said into the phone. “The Prime Minister himself? Of course, in that case, I will come round at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He replaced the receiver on the hook, and turned to his client.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My dear sir, I must ask you to excuse me. A most urgent summons. If you will give the facts of the case to my confidential secretary, she will deal with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He strode to the adjoining door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miss Robinson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence, very neat and demure with smooth black head and dainty collar and cuffs, tripped in. Tommy made the necessary introductions and departed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A lady you take an interest in has disappeared, I understand, Mr. St. Vincent,” said Tuppence, in her soft voice, as she sat down and took up Mr. Blunt’s pad and pencil. “A young lady?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! rather,” said Mr. St. Vincent. “Young—and—and—awfully good—looking and all that sort of thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence’s face grew grave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dear me,” she murmured. “I hope that—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t think anything’s really happened to her?” demanded Mr. St. Vincent, in lively concern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! we must hope for the best,” said Tuppence, with a kind of false cheerfulness which depressed Mr. St. Vincent horribly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! look here, Miss Robinson. I say, you must do something. Spare no expense. I wouldn’t have anything happen to her for the world. You seem awfully sympathetic, and I don’t mind telling you in confidence that I simply worship the ground that girl walks on. She’s a topper, an absolute topper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please tell me her name and all about her.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("“Her name’s Janet—I don’t know her second name. She works in a hat shop—Madame Violette’s in Brook Street—but she’s as straight as they make them. Has ticked me off no end of times—I went round there yesterday—waiting for her to come out—all the others came, but not her. Then I found that she’d never turned up that morning to work at all—sent no message either—old Madame was furious about it. I got the address of her lodgings, and I went round there. She hadn’t come home the night before, and they didn’t know where she was. I was simply frantic. I thought of going to the police. But I knew that Janet would be absolutely furious with me for doing that if she were really all right and had gone off on her own. Then I remembered that she herself had pointed out your advertisement to me one day in the paper and told me that one of the women who’d been in buying hats had simply raved about your ability and discretion and all that sort of thing. So I toddled along here right away.”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see,” said Tuppence. “What is the address of her lodgings?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man gave it to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s all, I think,” said Tuppence reflectively. “That is to say—am I to understand that you are engaged to this young lady?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. St. Vincent turned a brick red.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, no—not exactly. I never said anything. But I can tell you this, I mean to ask her to marry me as soon as ever I see her—if I ever do see her again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence laid aside her pad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you wish for our special twenty—four hour service?” she asked, in business like tones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The fees are doubled, but we put all our available staff on to the case. Mr. St. Vincent, if the lady is alive, I shall be able to tell you where she is by this time to—morrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? I say, that’s wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We only employ experts—and we guarantee results,” said Tuppence crisply.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“But I say, you know. You must have the most topping staff.”")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! we have,” said Tuppence. “By the way, you haven’t given me a description of the young lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s got the most marvelous hair—sort of golden, but very deep, like a jolly old sunset—that’s it, a, jolly old sunset. You know, I never noticed things like sunsets until lately. Poetry too, there’s a lot more in poetry than I ever thought.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Red hair,” said Tuppence unemotionally, writing it down. “What height should you say the lady was?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! tallish, and she’s got ripping eyes, dark blue, I think. And a sort of decided manner with her—takes a fellow up short sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence wrote down a few words more, then closed her note book and rose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you will call here to—morrow at two o’clock, I think we shall have news of some kind for you,” she said. “Good morning, Mr. St. Vincent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Tommy returned Tuppence was just consulting a page of Debrett. “I’ve got all the details,” she said succinctly. “Lawrence St. Vincent is the nephew and heir of the Earl of Cheriton. If we pull this through we shall get publicity in the highest places.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy read through the notes on the pad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you really think has happened to the girl?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think,” said Tuppence, “that she has fled at the dictates of her heart, feeling that she loves this young man too well for her peace of mind.” Tommy looked at her doubtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know they do it in books,” he said, “but I’ve never known any girl who did it in real life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No?” said Tuppence. “Well, perhaps you’re right. But I daresay Lawrence St. Vincent will swallow that sort of slush. He’s full of romantic notions just now. By the way, I guaranteed results in twenty—four hours—our special service.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tuppence—you congenital idiot, what made you do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The idea just came into my head. I thought it sounded rather well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Don’t you worry. Leave it to Mother. Mother knows best.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("She went out, leaving Tommy profoundly dissatisfied.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Presently he rose, sighed, and went out to do what could be done, cursing Tuppence’s over fervent imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he returned weary and jaded at half past four, he found Tuppence extracting a bag of biscuits from their place of concealment in one of the files.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You look hot and bothered,” she remarked. “What have you been doing?” Tommy groaned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Making a round of the Hospitals with that girl’s description.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t I tell you to leave it to me?” demanded Tuppence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t find that girl single handed before two o’clock tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can—and what’s more, I have!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have? What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A simple problem, Watson, very simple indeed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where is she now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence pointed a hand over her shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s in my office next door.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is she doing there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence began to laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” she said, “early training will tell, and with a kettle, a gas ring, and half a pound of tea staring her in the face, the result is a foregone conclusion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see,” continued Tuppence gently. “Madame Violette’s is where I go for my hats, and the other day I ran across an old pal of Hospital days amongst the girls there. She gave up nursing after the War and started a hat shop, failed, and took this job at Madame Violette’s. We fixed up the whole thing between us. She was to rub the advertisement well into young St. Vincent, and then disappear. Wonderful efficiency of Blunt’s Brilliant Detectives. Publicity for us and the necessary fillip to young St. Vincent to bring him to the point of proposing. Janet was in despair about it.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Tuppence,” said Tommy, “you take my breath away! The whole thing is the most immoral business I ever heard of. You aid and abet this young man to marry out of his class—”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stuff,” said Tuppence. “Janet is a splendid girl—and the queer thing is that she really adores that weak kneed young man. You can see with half a glance what his family needs. Some good red blood in it. Janet will be the making of him. She’ll look after him like a mother, ease down the cocktails and the night clubs and make him lead a good healthy country gentleman’s life. Come and meet her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence opened the door of the adjoining office and Tommy followed her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A tall girl with lovely auburn hair, and a pleasant face, put down the steaming kettle in her hand, and turned with a smile that disclosed an even row of white teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hope you’ll forgive me, Nurse Cowley—Mrs. Beresford, I mean. I thought that very likely you’d be quite ready for a cup of tea yourself. Many’s the pot of tea you’ve made for me in the Hospital at three o’clock in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tommy,” said Tuppence. “Let me introduce you to my old friend, Nurse Smith.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smith, did you say? How curious!” said Tommy, shaking hands. “Eh? Oh! nothing—a little monograph that I was thinking of Writing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pull yourself together, Tommy,” said Tuppence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She poured him out a cup of tea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, then, let’s all drink together. Here’s to the success of the International Detective Agency. Blunt’s Brilliant Detectives! May they never know failure!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599e12f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Chapter02.vue
// module id = 78
// module chunks = 0